import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-mail',
  templateUrl: './confirm-mail.component.html',
  styleUrls: ['./confirm-mail.component.css']
})
export class ConfirmMailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
